import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import {  SocketIoConfig, SocketIoModule } from 'ngx-socket-io';

// import * as $ from 'jquery';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
import { ProjectselectComponent } from './projectselect/projectselect.component';
// import { LoginServicesService } from './login-services.service';
import { Config } from './config';
import { RegisterComponent } from './register/register.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { MainComponent } from './main/main.component';
import { LandscaperComponent } from './landscaper/landscaper.component';

import { LoginServicesService } from './shared/services/login-services.service';
import { ProjectServicesService } from './shared/services/project-services.service';
import { AppService } from './shared/services/app.service';
import { SharedService } from './shared/services/shared.service';
import { UserManagementService } from './shared/services/user-management.service';
import { PlannerComponent } from './planner/planner.component';
import { CommonPipe } from './shared/filters/common.pipe';
import { PlannerPipe } from './shared/filters/planner.pipe';
import { ProjectTabPipe } from './shared/filters/project-tab.pipe';
import { MytasksTabPipe } from './shared/filters/mytasks-tab.pipe';
import { SessionTabPipe } from './shared/filters/session-tab.pipe';
import { PlanNamePipe } from './shared/filters/plan-name.pipe';
import { LandscaperEntityPipe } from './shared/filters/landscaper-entity.pipe';
import { PersonaMapperComponent } from './persona-mapper/persona-mapper.component';
import { DeepDiveComponent } from './deep-dive/deep-dive.component';
import { TestDesignerComponent } from './test-designer/test-designer.component';
import { InteractionMapperComponent } from './interaction-mapper/interaction-mapper.component';
import { QuillModule } from 'ngx-quill';
import { TestExecutorComponent } from './test-executor/test-executor.component';
import { ScopeMapperComponent } from './scope-mapper/scope-mapper.component';
import { ChecklistComponent } from './checklist/checklist.component';
import { EnvironmentMapperComponent } from './environment-mapper/environment-mapper.component';
import { TestManagerComponent } from './test-manager/test-manager.component';
import diff from 'fast-diff';
import QuillType from 'quill';
declare module 'quill';
import Delta from 'quill';
import { TaskPlannerComponent } from './task-planner/task-planner.component';
import { TaskPlannerEUTFilterWithSearchTextPipe } from './shared/filters/task-planner-eutfilter-with-search-text.pipe';
import { TaskPlannerEnvironmentFilterWithSearchTextPipe } from './shared/filters/task-planner-environment-filter-with-search-text.pipe';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SortPipe } from './shared/filters/sort.pipe';
import { CockpitReportComponent } from './cockpit-report/cockpit-report.component';
import { ExportReportComponent } from './export-report/export-report.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { MyNotesComponent } from './my-notes/my-notes.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { ConfirmregisterComponent } from './confirmregister/confirmregister.component';
import { ConfirminviteComponent } from './confirminvite/confirminvite.component';
import { ScenariofilterPipePipe } from './shared/filters/scenariofilter-pipe.pipe';
import { ExecutorscenariofilterPipePipe } from './shared/filters/executorscenariofilter-pipe.pipe';
import { TestmanagerprojectfilterPipe } from './shared/filters/testmanagerprojectfilter.pipe';
import { TestmanagersuitefilterPipe } from './shared/filters/testmanagersuitefilter.pipe';
import { DashboardExecutionComponent } from './dashboard-execution/dashboard-execution.component';
import { DashboardQualityComponent } from './dashboard-quality/dashboard-quality.component';
import { PagerService } from './shared/services/pager.service';
import { ReloadToolService } from './shared/services/reload-tool.service';
import { MyNoteFilterWithSearchTextPipe } from './shared/filters/my-note-filter-with-search-text.pipe';
import { JiraTestingComponent } from './jira-testing/jira-testing.component';
import { JiraUserStoriesComponent } from './jira-user-stories/jira-user-stories.component';
import { JiraUserService } from './shared/services/jira-user.service';
import { JiraBugsListComponent } from './jira-bugs-list/jira-bugs-list.component';
import { JiraSearchPipe } from './shared/filters/jira-search.pipe';
import { SprintPlannerComponent } from './sprint-planner/sprint-planner.component';
import { SprintNamePipe } from './shared/filters/sprint-name.pipe';
import { SprintTabPipe } from './shared/filters/sprint-tab.pipe';
import { SprintPlannerPlusComponent } from './sprint-planner-plus/sprint-planner-plus.component';
import { InteractionMapperMindMapComponent } from './interaction-mapper-mind-map/interaction-mapper-mind-map.component';
import { SafeHtmlPipe } from './shared/filters/safe-html.pipe';
import { PersonaMapperMindMapComponent } from './persona-mapper-mind-map/persona-mapper-mind-map.component';
import { ScopeMapperMindMapComponent } from './scope-mapper-mind-map/scope-mapper-mind-map.component';
import { ProgressBarModule } from 'angular-progress-bar';
import { JirabugsMapperComponent } from './jirabugs-mapper/jirabugs-mapper.component';
import { JiraBugsSearchPipePipe } from './shared/filters/jira-bugs-search-pipe.pipe';
import { EntityTestComponent } from './entity-test/entity-test.component';
import { EntityTestCoverageComponent } from './entity-test-coverage/entity-test-coverage.component';
import { EntitytestscenariofilterPipe } from './shared/filters/entitytestscenariofilter.pipe';
import { ModuleEntityListFilterPipe } from './shared/filters/module-entity-list-filter.pipe';
import { EntityMapperFilterPipe } from './shared/filters/entity-mapper-filter.pipe';
import { PersonaMapperEntityMindMapComponent } from './persona-mapper-entity-mind-map/persona-mapper-entity-mind-map.component';
import { ScopeMapperEntityMindMapComponent } from './scope-mapper-entity-mind-map/scope-mapper-entity-mind-map.component';
import { MindElixirMindmappingComponent } from './mind-elixir-mindmapping/mind-elixir-mindmapping.component';
import { ChatGptAssistantComponent } from './chat-gpt-assistant/chat-gpt-assistant.component';
// import { MindMappingToolComponent } from './mind-mapping-tool/mind-mapping-tool.component';
// import QuillType from 'quill';
// const configSocket: SocketIoConfig = { url: 'http://localhost:8000', options: { transports: ['websocket']} };
// const configSocket: SocketIoConfig = { url: 'http://dosmartqa.stagsoftware.net:3005', options: { transports: ['websocket']} }; // 3005 port number which is for UI in PROD  [ , allowUpgrades : true
const configSocket: SocketIoConfig = { url: 'http://dosmartqa.stagsoftware.net:3009', options: { transports: ['websocket']} }; // 3009 port number which is for UI in DEV  [ , allowUpgrades : true

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProjectselectComponent,
    RegisterComponent,
    ForgotpasswordComponent,
    MainComponent,
    LandscaperComponent,
    PlannerComponent,
    CommonPipe,
    PlannerPipe,
    ProjectTabPipe,
    MytasksTabPipe,
    SessionTabPipe,
    PlanNamePipe,
    LandscaperEntityPipe,
    PersonaMapperComponent,
    PersonaMapperMindMapComponent,
    DeepDiveComponent,
    TestDesignerComponent,
    InteractionMapperComponent,
    TestExecutorComponent,
    ScopeMapperComponent,
    ScopeMapperMindMapComponent,
    ChecklistComponent,
    EnvironmentMapperComponent,
    TestManagerComponent,
    TaskPlannerComponent,
    TaskPlannerEUTFilterWithSearchTextPipe,
    TaskPlannerEnvironmentFilterWithSearchTextPipe,
    ModuleEntityListFilterPipe,
    DashboardComponent,
    SortPipe,
    CockpitReportComponent,
    ExportReportComponent,
    NotificationsComponent,
    MyNotesComponent,
    ResetpasswordComponent,
    ConfirmregisterComponent,
    ConfirminviteComponent,
    ScenariofilterPipePipe,
    ExecutorscenariofilterPipePipe,
    EntitytestscenariofilterPipe,
    TestmanagerprojectfilterPipe,
    TestmanagersuitefilterPipe,
    DashboardExecutionComponent,
    DashboardQualityComponent,
    MyNoteFilterWithSearchTextPipe,
    JiraTestingComponent,
    JiraUserStoriesComponent,
    JiraBugsListComponent,
    JiraSearchPipe,
    SprintPlannerComponent,
    SprintNamePipe,
    SprintTabPipe,
    SprintPlannerPlusComponent,
    InteractionMapperMindMapComponent,
    SafeHtmlPipe,
    PersonaMapperMindMapComponent,
    ScopeMapperMindMapComponent,
    JirabugsMapperComponent,
    JiraBugsSearchPipePipe,
    EntityTestComponent,
    EntityTestCoverageComponent,
    EntityMapperFilterPipe,
    PersonaMapperEntityMindMapComponent,
    ScopeMapperEntityMindMapComponent,
    MindElixirMindmappingComponent,
    ChatGptAssistantComponent,
    // AppRoutingModule.forRoot(routes, {
    //   onSameUrlNavigation: 'reload'
    // })
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    FontAwesomeModule,
    QuillModule.forRoot(),
    QuillModule,
    FormsModule,
    ProgressBarModule,
    SocketIoModule.forRoot(configSocket)
  ],
  providers: [
    Config,
    ProjectServicesService,
    LoginServicesService,
    AppService,
    SharedService,
    ReloadToolService,
    UserManagementService,
    PlannerComponent,
    InteractionMapperComponent,
    InteractionMapperMindMapComponent,
    ScopeMapperComponent,
    TaskPlannerComponent,
    ChecklistComponent,
    DeepDiveComponent,
    TestDesignerComponent,
    TestExecutorComponent,
    NotificationsComponent,
    DashboardComponent,
    LandscaperComponent,
    TestManagerComponent,
    PagerService,
    JiraUserService,
    JiraBugsListComponent
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
